import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, input, Input, OnDestroy, OnInit, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'clever-flightzeit',
    templateUrl: './flugzeit.component.html',
    styleUrls: ['./flugzeit.component.scss'],
    standalone: false
})
export class FlightzeitComponent implements OnInit {
    mode = input<string>('');
    title = input<string>('');
    step = input<number>(5);
    minValue = input<number>(0);
    maxValue = input<number>(1440);

    isHinflug = input<boolean>(false);

    isBrowser = signal<boolean>(false);

    min = signal<number>(0);
    max = signal<number>(1440);
    minValue_t = signal<number>(0);
    maxValue_t = signal<number>(1440);

    minPercent = signal<number>(0);
    maxPercent = signal<number>(0);
    rangeWidth = signal<number>(0);

    destroyRef = inject(DestroyRef);

    constructor(
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initFilterSub();
        }
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (filter) {
                if (this.isHinflug()) {
                    if (filter.maxdepartureTime > 0 && filter.maxdepartureTime < 1440) {
                        this.maxValue_t.set(filter.maxdepartureTime);
                    } else {
                        this.maxValue_t.set(1440);
                    }
                    if (filter.mindepartureTime > 0 && filter.mindepartureTime < 1440) {
                        this.minValue_t.set(filter.mindepartureTime);
                    } else {
                        this.minValue_t.set(0);
                    }
                } else {
                    if (filter.maxreturnTime > 0 && filter.maxreturnTime < 1440) {
                        this.maxValue_t.set(filter.maxreturnTime);
                    } else {
                        this.maxValue_t.set(1440);
                    }
                    if (filter.minreturnTime > 0 && filter.minreturnTime < 1440) {
                        this.minValue_t.set(filter.minreturnTime);
                    } else {
                        this.minValue_t.set(0);
                    }
                }
            }
            this.updateRange(this.minValue_t(), this.maxValue_t())
        });

    }

    updateRange(tminValue, tmaxValue) {
        this.minValue_t.set(tminValue);
        this.maxValue_t.set(tmaxValue);
        if (this.minValue_t() > this.maxValue() - this.step()) {
            this.minValue_t.set(this.maxValue() - this.step());
        }

        if (this.maxValue_t() < this.minValue() + this.step()) {
            this.maxValue_t.set(this.minValue() + this.step());
        }

        this.minPercent.set((this.minValue_t() / this.max()) * 100);
        this.maxPercent.set((this.maxValue_t() / this.max()) * 100);
        this.rangeWidth.set(this.maxPercent() - this.minPercent());

    }

    sendValue(): void {
        if (this.isHinflug()) {
            this.hotelService.departureTime({ min: this.minValue_t(), max: this.maxValue_t() }, this.mode() !== 'home');
        } else if (!this.isHinflug()) {
            this.hotelService.returnTime({ min: this.minValue_t(), max: this.maxValue_t() }, this.mode() !== 'home');
        }
    }

    transformMinute(value: number): string {
        const hours = ('00' + Math.floor(value / 60)).slice(-2);
        const minutes = ('00' + Math.floor(value % 60)).slice(-2);
        return hours + ':' + minutes;
    }
}
